function CacheItem ( data, ttl ) {
	this.setTTL( ttl );
	this.setData( data );
}

CacheItem.prototype.data = null;
CacheItem.prototype.ttl = null;
CacheItem.ERROR_MESSAGE_UNRECOGNIZED_TTL = 'Cache item TTL string not recognised. Please use one of days:{numberOfDays}, hours:{numberOfHours}, minutes:{numberOfMinutes}, seconds:{numberOfSeconds}';

CacheItem.prototype.setTTL = function ( ttlValue ) {
	const option = ttlValue.split( ':' );

	if ( option.length !== 2 ) {
		throw new Error( CacheItem.ERROR_MESSAGE_UNRECOGNIZED_TTL );
	}

	const optionObject = {
		intervalType: option[ 0 ],
		amount: parseInt( option[ 1 ], 10 ),
	};

	const date = new Date();

	if ( optionObject.intervalType === 'days' ) {
		date.setDate( date.getDate() + optionObject.amount );
		this.ttl = date.getTime();
		return;
	}

	if ( optionObject.intervalType === 'hours' ) {
		date.setTime( date.getTime() + ( optionObject.amount * 60 * 60000 ) );
		this.ttl = date.getTime();
		return;
	}

	if ( optionObject.intervalType === 'minutes' ) {
		date.setTime( date.getTime() + ( optionObject.amount * 60000 ) );
		this.ttl = date.getTime();
		return;
	}

	if ( optionObject.intervalType === 'seconds' ) {
		date.setTime( date.getTime() + ( ( optionObject.amount / 60 ) * 60000 ) );
		this.ttl = date.getTime();
		return;
	}

	throw new Error( CacheItem.ERROR_MESSAGE_UNRECOGNIZED_TTL );
};

CacheItem.prototype.setData = function ( dataObject ) {
	if ( typeof dataObject === 'string' ) {
		this.data = dataObject;
	} else {
		this.data = JSON.stringify( dataObject );
	}
};

function DataCacheRepository () {

}

DataCacheRepository.KEY_USER_DATA = 'user-data';
DataCacheRepository.TTL_USER_DATA = 'minutes:30';

DataCacheRepository.KEY_NS_ACCOUNT_SIGN_IN = 'account_sign_in';
DataCacheRepository.TTL_SIGN_IN = 'days:1';

DataCacheRepository.STORAGE_LOCAL = 'local';
DataCacheRepository.STORAGE_SESSION = 'session';

DataCacheRepository.ERROR_MESSAGE_STORAGE_TYPE = 'Storage not recognised';

DataCacheRepository.isFresh = cacheItem => {
	const now = new Date();
	const nowTime = now.getTime();
	return cacheItem.ttl >= nowTime;
};

DataCacheRepository.getItem = itemKey => {
	let data = window.localStorage.getItem( itemKey );
	let storageType = DataCacheRepository.STORAGE_LOCAL;

	if ( ! data ) {
		data = window.sessionStorage.getItem( itemKey );
		storageType = DataCacheRepository.STORAGE_SESSION;
	}

	if ( ! data ) {
		return null;
	}

	let dataObject;
	try {
		dataObject = JSON.parse( data );
	} catch ( e ) {
		if ( storageType === DataCacheRepository.STORAGE_LOCAL ) {
			window.localStorage.removeItem( itemKey );
		}
		if ( storageType === DataCacheRepository.STORAGE_SESSION ) {
			window.sessionStorage.removeItem( itemKey );
		}
		return null;
	}

	if ( ! DataCacheRepository.isFresh( dataObject ) ) {
		if ( storageType === DataCacheRepository.STORAGE_LOCAL ) {
			window.localStorage.removeItem( itemKey );
		}
		if ( storageType === DataCacheRepository.STORAGE_SESSION ) {
			window.sessionStorage.removeItem( itemKey );
		}
		return null;
	}

	return dataObject;
};

DataCacheRepository.setItem = ( itemData, itemKey, itemTTL, storageChoice = DataCacheRepository.STORAGE_LOCAL ) => {
	if ( storageChoice === DataCacheRepository.STORAGE_LOCAL ) {
		window.localStorage.setItem( itemKey, JSON.stringify( DataCacheRepository.buildCacheItem( itemData, itemTTL ) ) );
		return;
	}

	if ( storageChoice === DataCacheRepository.STORAGE_SESSION ) {
		window.sessionStorage.setItem( itemKey, JSON.stringify( DataCacheRepository.buildCacheItem( itemData, itemTTL ) ) );
		return;
	}

	throw new Error( DataCacheRepository.ERROR_MESSAGE_STORAGE_TYPE );
};

DataCacheRepository.removeItem = ( itemKey, storageChoice ) => {
	if ( storageChoice === DataCacheRepository.STORAGE_LOCAL ) {
		window.localStorage.removeItem( itemKey );
		return;
	}

	if ( storageChoice === DataCacheRepository.STORAGE_SESSION ) {
		window.sessionStorage.removeItem( itemKey );
		return;
	}

	throw new Error( DataCacheRepository.ERROR_MESSAGE_STORAGE_TYPE );
};

DataCacheRepository.buildCacheItem = ( data, ttl ) => {
	return new CacheItem( data, ttl );
};

export default DataCacheRepository;
